export { default } from './ArrowDownRight'
